import { HiBriefcase } from "react-icons/hi2";

export const ProjectsIcon = ({ width, height, color, ...props }) => (
  <HiBriefcase
    size={width || height || 25}
    color={color || "currentColor"}
    {...props}
  />
);
